import type { ReactNode } from 'react';

interface SiteLayoutProps {
  children: ReactNode;
  header: ReactNode;
  footer: ReactNode;
  className?: string;
}

const SiteLayout = ({ children, header, footer, className = '' }: SiteLayoutProps) => (
  <div className={`flex min-h-screen flex-col ${className}`}>
    {header}
    <main className="flex-grow">{children}</main>
    {footer}
  </div>
);

export default SiteLayout;
